import { ReactNode } from 'react';

import { ClassName, I18nText } from '../../../../../types';
import {
  OperationUUID,
  FetchOperationsCacheKeys,
  FetchOperationsErrorMessage,
  FetchOperationsFetched,
  FetchOperationsFilters,
  FetchOperationsFilterOperations,
  FetchOperationsIsPlaceholderData,
  FetchOperationsLimit,
  FetchOperationsPage,
  FetchOperationsPaginateOperations,
  FetchOperationsPrefetchOperations,
  FetchOperationsSort,
  FetchOperationsSortOperations,
  FetchOperationsTotalCount,
  FetchOperationsShowOperation
} from '../../../operationsTypes';
import { TeamNanoID } from '../../../../teams/teamsTypes';
import { UserID } from '../../../../users/usersTypes';
import { UpdateOperationModalButtonAccess } from '../../../components/modalButtons/UpdateOperationModalButton';

import { ItemsIndexTableWrapper } from '../../../../common/components/tables/ItemsIndexTableWrapper';

import {
  CompanyOperationsCompactTableBody,
  CompanyOperationsCompactTableBodyOperations
} from '../CompanyOperationsCompactTableBody';
import { CompanyOperationsCompactTableHeader } from '../CompanyOperationsCompactTableHeader';

interface CompanyOperationsCompactTableProps {
  teamNanoId?: TeamNanoID;
  cacheKeys?: FetchOperationsCacheKeys;
  clientsIds?: UserID[];
  paginateOperations: FetchOperationsPaginateOperations;
  prefetchOperations: FetchOperationsPrefetchOperations;
  sortOperations: FetchOperationsSortOperations;
  operations: CompanyOperationsCompactTableBodyOperations;
  operationsError: FetchOperationsErrorMessage;
  operationsFetched: FetchOperationsFetched;
  operationsIsPlaceholderData: FetchOperationsIsPlaceholderData;
  operationsLimit: FetchOperationsLimit;
  operationsPage: FetchOperationsPage;
  operationsSort: FetchOperationsSort;
  operationsTotalCount: FetchOperationsTotalCount;
  withEmptyTable?: boolean;
  withUpdateButton?: boolean;
  updateButtonAccess: UpdateOperationModalButtonAccess;
  selectedOperationUuid?: OperationUUID;
  operationsFilters: FetchOperationsFilters;
  changeOperationsFilters: FetchOperationsFilterOperations;
  noOperationsTableRow?: ReactNode;
  customI18nCompleteDatetimeTitle?: I18nText;
  customI18nDateTitle?: I18nText;
  onOperationShow?: FetchOperationsShowOperation;
  onOperationShowMouseOver?: FetchOperationsShowOperation;
  indexTableClassName?: ClassName;
}

function CompanyOperationsCompactTable({
  cacheKeys,
  clientsIds,
  teamNanoId,
  paginateOperations,
  prefetchOperations,
  sortOperations,
  operations,
  operationsError,
  operationsFetched,
  operationsIsPlaceholderData,
  operationsLimit,
  operationsPage,
  operationsSort,
  operationsTotalCount,
  withEmptyTable,
  withUpdateButton,
  updateButtonAccess,
  selectedOperationUuid,
  operationsFilters,
  changeOperationsFilters,
  noOperationsTableRow,
  customI18nCompleteDatetimeTitle,
  customI18nDateTitle,
  onOperationShow,
  onOperationShowMouseOver,
  indexTableClassName
}: CompanyOperationsCompactTableProps) {
  return (
    <ItemsIndexTableWrapper
      scope="operations"
      items={operations}
      itemsFetched={operationsFetched}
      itemsError={operationsError}
      itemsIsPlaceholderData={operationsIsPlaceholderData}
      itemsPage={operationsPage}
      itemsLimit={operationsLimit}
      itemsTotalCount={operationsTotalCount}
      paginateItems={paginateOperations}
      prefetchItems={prefetchOperations}
      withEmptyTable={withEmptyTable}
      indexTableClassName={indexTableClassName}
    >
      <CompanyOperationsCompactTableHeader
        changeOperationsFilters={changeOperationsFilters}
        sortOperations={sortOperations}
        operationsFilters={operationsFilters}
        operationsSort={operationsSort}
        clientsIds={clientsIds}
        withUpdateButton={withUpdateButton}
        customI18nCompleteDatetimeTitle={customI18nCompleteDatetimeTitle}
        customI18nDateTitle={customI18nDateTitle}
      />
      <CompanyOperationsCompactTableBody
        cacheKeys={cacheKeys}
        operations={operations}
        clientsIds={clientsIds}
        teamNanoId={teamNanoId}
        noOperationsTableRow={noOperationsTableRow}
        withUpdateButton={withUpdateButton}
        updateButtonAccess={updateButtonAccess}
        selectedOperationUuid={selectedOperationUuid}
        onOperationShow={onOperationShow}
        onOperationShowMouseOver={onOperationShowMouseOver}
      />
    </ItemsIndexTableWrapper>
  );
}

export default CompanyOperationsCompactTable;
